export const typeToIDs = {
    blog: [4, 'HealthUnlocked.Aurora.DataModel.Content.Blog'],
    answer: [2, 'HealthUnlocked.Aurora.DataModel.Content.Answer'],
    reply: [19, 'HealthUnlocked.Aurora.DataModel.Content.Comment'],
    poll: [6, 'HealthUnlocked.Aurora.DataModel.Content.Poll'],
    question: [1, 'HealthUnlocked.Aurora.DataModel.Content.Question'],
    pollChoice: [7, 'HealthUnlocked.Aurora.DataModel.Content.PollChoice'],
};

const idToProcess = {};
Object.entries(typeToIDs).forEach(
  ([key, values]) => values.forEach(
    value => idToProcess[value] = key
  )
);
export { idToProcess };


export function processAccordingPostType(post = {}, processes = {}) {
  return processes[idToProcess[post.postTypeId]];
}



// WEBPACK FOOTER //
// ./~/virgo/src/utils/processAccordingPostType.js